export type PreviewRect = Pick<DOMRect, 'left' | 'right' | 'top' | 'bottom'>;
export type PreviewSize = { width: number; height: number };

export function derivePreviewImageUrl(source: string): string {
  try {
    const url = new URL(source);
    if (url.protocol !== 'https:' || url.hostname !== 'tcgplayer-cdn.tcgplayer.com') return source;
    const match = /^\/product\/(\d+)_200w\.jpg$/.exec(url.pathname);
    if (!match) return source;
    url.pathname = `/product/${match[1]}_400w.jpg`;
    return url.toString();
  } catch {
    return source;
  }
}

export function placePreview(anchor: PreviewRect, preview: PreviewSize, viewport: PreviewSize) {
  const gap = 12;
  const maximumLeft = Math.max(0, viewport.width - preview.width - gap);
  const verticalSpace = Math.max(0, viewport.height - preview.height);
  const minimumTop = verticalSpace < gap * 2 ? verticalSpace / 2 : gap;
  const maximumTop = verticalSpace < gap * 2 ? verticalSpace / 2 : verticalSpace - gap;
  const preferredLeft = anchor.right + gap + preview.width <= viewport.width
    ? anchor.right + gap
    : anchor.left - preview.width - gap;
  const centeredTop = anchor.top - (preview.height - (anchor.bottom - anchor.top)) / 2;
  return {
    left: Math.min(Math.max(0, preferredLeft), maximumLeft),
    top: Math.min(Math.max(minimumTop, centeredTop), maximumTop),
  };
}
